import { createTheme } from "@mui/material/styles";

function paletteColor(value, fallback) {
  if (
    typeof value === "string" &&
    /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value.trim())
  ) {
    return value.trim();
  }
  return fallback;
}

export function createAppMuiTheme(themeColors) {
  const primary = paletteColor(themeColors.primary, "#44745E");
  const text = paletteColor(themeColors.text, "#000000");
  const scaffold = paletteColor(themeColors.scaffold, "#ffffff");
  const container = paletteColor(themeColors.container, "#ffffff");
  const appBar = paletteColor(themeColors.appBar, "#fafeff");
  const appBarText = paletteColor(themeColors.appBarText, "#000000");

  return createTheme({
    palette: {
      primary: {
        main: primary,
        contrastText: text,
      },
      background: {
        default: scaffold,
        paper: container,
      },
      text: {
        primary: text,
      },
      divider: themeColors.border,
    },
    shape: {
      borderRadius: 20,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: appBar,
            color: appBarText,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            backgroundColor: primary,
            color: text,
          },
        },
      },
    },
  });
}
